import OrderStrategy from "./OrderStrategy";

export const DefineByExecutor = OrderStrategy(0, "edi.orders.add_order.order_lifecycle.contract_info_strategy.select.0");
export const DefineInOrder = OrderStrategy(1, "edi.orders.add_order.order_lifecycle.contract_info_strategy.select.1");